<form #personForm="ngForm" class="user-dialog-shell" (ngSubmit)="save(personForm.valid)">
  <header class="user-dialog-header">
    <h2 id="organization-user-title">{{ isNewUser ? 'Lägg till administratör' : 'Redigera administratör' }}</h2>
    <button mat-icon-button type="button" aria-label="Stäng dialogen" matTooltip="Stäng" [disabled]="saving" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <mat-dialog-content class="user-dialog-content">
    <p *ngIf="isNewUser" class="description">Sök med personnummer. En befintlig person utan organisation kopplas till företaget. För en ny person skapas ett konto och ett välkomstmejl skickas.</p>
    <div class="user-form">
      <mat-form-field floatLabel="always" class="form-wide">
        <mat-label>Personnummer</mat-label>
        <input matInput name="personalNumber" [(ngModel)]="user.PersonalNumber"
               (ngModelChange)="lookupPerson($event)" [disabled]="!isNewUser || saving"
               inputmode="numeric" pattern="[0-9]{12}" maxlength="12" placeholder="ÅÅÅÅMMDDNNNN" required>
        <mat-hint>12 siffror utan bindestreck</mat-hint>
        <mat-error>Ange personnummer med 12 siffror.</mat-error>
      </mat-form-field>
      <div class="form-wide lookup-status" aria-live="polite" *ngIf="isNewUser">
        <p *ngIf="searching">Hämtar personuppgifter…</p>
        <p *ngIf="existingUser">Personen finns redan. Kontouppgifterna behålls och inget nytt välkomstmejl skickas.</p>
        <p *ngIf="personVerified && !existingUser">Nytt konto. Ett välkomstmejl skickas till e-postadressen nedan.</p>
        <p *ngIf="lookupError" class="dialog-error" role="alert">{{ lookupError }}</p>
        <button *ngIf="lookupError" mat-stroked-button type="button" (click)="lookupPerson(user.PersonalNumber)">Försök igen</button>
      </div>
      <mat-form-field floatLabel="always">
        <mat-label>Förnamn</mat-label>
        <input matInput name="firstName" [(ngModel)]="user.FirstName" disabled>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>Efternamn</mat-label>
        <input matInput name="lastName" [(ngModel)]="user.LastName" disabled>
      </mat-form-field>
      <mat-form-field floatLabel="always" class="form-wide">
        <mat-label>E-postadress</mat-label>
        <input matInput type="email" name="email" [(ngModel)]="user.Email" [disabled]="saving || existingUser || !isNewUser" required email>
        <mat-error>Ange en giltig e-postadress.</mat-error>
      </mat-form-field>
      <mat-form-field floatLabel="always" class="form-wide">
        <mat-label>Roller</mat-label>
        <mat-select name="roles" [(ngModel)]="user.RoleIds" multiple [required]="isNewUser" [disabled]="saving || rolesLoading">
          <mat-option *ngFor="let role of roles" [value]="role.Id">{{ role.Name === 'companyadmin' ? 'Administratör' : role.Name }}</mat-option>
        </mat-select>
        <mat-error>Välj administratörsrollen.</mat-error>
      </mat-form-field>
      <mat-checkbox *ngIf="!isNewUser" name="suspended" [(ngModel)]="user.Suspended" [disabled]="saving">Kontot spärrat</mat-checkbox>
    </div>
  </mat-dialog-content>

  <footer class="user-dialog-footer">
    <div class="user-dialog-actions">
      <button mat-stroked-button type="button" [disabled]="saving" (click)="cancel()">Avbryt</button>
      <button mat-raised-button color="accent" type="submit"
              [disabled]="!personForm.valid || saving || searching || rolesLoading || (isNewUser && (!personVerified || !user.RoleIds?.length))">
        {{ saving ? 'Sparar…' : !isNewUser ? 'Spara' : existingUser ? 'Lägg till administratör' : 'Skapa och skicka mejl' }}
      </button>
    </div>
    <p *ngIf="errorMessage" class="dialog-error" role="alert">{{ errorMessage }}</p>
  </footer>
</form>
